import type { BlogContentMap } from './blog.types';

export const BLOG_CONTENT: BlogContentMap = {
  en: {
    hero: { badge: 'Blog', title: 'HotelStack.io Blog', subtitle: 'Insights, guides, and best practices for modern hotel management' },
    filters: { all: 'All', guides: 'Guides', industry: 'Industry', product: 'Product', trends: 'Trends' },
    categories: { all: 'All', guides: 'Guides', industry: 'Industry', product: 'Product', trends: 'Trends' },
    empty: 'No articles found in this category.',
    cta: { title: 'Ready to Modernise Your Hotel?', subtitle: 'Join 500+ hotels using HotelStack.io to streamline operations and boost revenue.', trialBtn: 'Start Free Trial', contactBtn: 'Contact Sales' },
    card: { readTimeUnit: 'min read' },
  },
  ar: {
    hero: { badge: 'المدونة', title: 'مدونة HotelStack.io', subtitle: 'رؤى وأدلة وأفضل الممارسات لإدارة الفنادق الحديثة' },
    filters: { all: 'الكل', guides: 'أدلة', industry: 'الصناعة', product: 'المنتج', trends: 'الاتجاهات' },
    categories: { all: 'الكل', guides: 'أدلة', industry: 'الصناعة', product: 'المنتج', trends: 'الاتجاهات' },
    empty: 'لم يتم العثور على مقالات في هذه الفئة.',
    cta: { title: 'هل أنت مستعد لتحديث فندقك؟', subtitle: 'انضم إلى أكثر من ٥٠٠ فندق يستخدمون HotelStack.io لتبسيط العمليات وزيادة الإيرادات.', trialBtn: 'ابدأ تجربة مجانية', contactBtn: 'اتصل بالمبيعات' },
    card: { readTimeUnit: 'دقيقة قراءة' },
  },
  th: {
    hero: { badge: 'บล็อก', title: 'บล็อก HotelStack.io', subtitle: 'ข้อมูลเชิงลึก คู่มือ และแนวทางปฏิบัติที่ดีที่สุดสำหรับการจัดการโรงแรมสมัยใหม่' },
    filters: { all: 'ทั้งหมด', guides: 'คู่มือ', industry: 'อุตสาหกรรม', product: 'ผลิตภัณฑ์', trends: 'แนวโน้ม' },
    categories: { all: 'ทั้งหมด', guides: 'คู่มือ', industry: 'อุตสาหกรรม', product: 'ผลิตภัณฑ์', trends: 'แนวโน้ม' },
    empty: 'ไม่พบบทความในหมวดหมู่นี้',
    cta: { title: 'พร้อมที่จะปรับปรุงโรงแรมของคุณหรือยัง?', subtitle: 'เข้าร่วมกับโรงแรมกว่า 500 แห่งที่ใช้ HotelStack.io เพื่อปรับปรุงการดำเนินงานและเพิ่มรายได้', trialBtn: 'เริ่มทดลองใช้ฟรี', contactBtn: 'ติดต่อฝ่ายขาย' },
    card: { readTimeUnit: 'นาทีในการอ่าน' },
  },
  es: {
    hero: { badge: 'Blog', title: 'Blog de HotelStack.io', subtitle: 'Perspectivas, guías y mejores prácticas para la gestión hotelera moderna' },
    filters: { all: 'Todos', guides: 'Guías', industry: 'Industria', product: 'Producto', trends: 'Tendencias' },
    categories: { all: 'Todos', guides: 'Guías', industry: 'Industria', product: 'Producto', trends: 'Tendencias' },
    empty: 'No se encontraron artículos en esta categoría.',
    cta: { title: '¿Listo para modernizar su hotel?', subtitle: 'Únase a más de 500 hoteles que usan HotelStack.io para optimizar operaciones y aumentar ingresos.', trialBtn: 'Prueba gratuita', contactBtn: 'Contactar ventas' },
    card: { readTimeUnit: 'min de lectura' },
  },
  fr: {
    hero: { badge: 'Blog', title: 'Blog HotelStack.io', subtitle: 'Perspectives, guides et meilleures pratiques pour la gestion hôtelière moderne' },
    filters: { all: 'Tous', guides: 'Guides', industry: 'Industrie', product: 'Produit', trends: 'Tendances' },
    categories: { all: 'Tous', guides: 'Guides', industry: 'Industrie', product: 'Produit', trends: 'Tendances' },
    empty: 'Aucun article trouvé dans cette catégorie.',
    cta: { title: 'Prêt à moderniser votre hôtel ?', subtitle: 'Rejoignez plus de 500 hôtels qui utilisent HotelStack.io pour optimiser leurs opérations et augmenter leurs revenus.', trialBtn: 'Essai gratuit', contactBtn: 'Contacter les ventes' },
    card: { readTimeUnit: 'min de lecture' },
  },
  de: {
    hero: { badge: 'Blog', title: 'HotelStack.io Blog', subtitle: 'Einblicke, Leitfäden und Best Practices für modernes Hotelmanagement' },
    filters: { all: 'Alle', guides: 'Leitfäden', industry: 'Branche', product: 'Produkt', trends: 'Trends' },
    categories: { all: 'Alle', guides: 'Leitfäden', industry: 'Branche', product: 'Produkt', trends: 'Trends' },
    empty: 'Keine Artikel in dieser Kategorie gefunden.',
    cta: { title: 'Bereit, Ihr Hotel zu modernisieren?', subtitle: 'Schließen Sie sich über 500 Hotels an, die HotelStack.io nutzen, um Abläufe zu optimieren und Umsätze zu steigern.', trialBtn: 'Kostenlos testen', contactBtn: 'Vertrieb kontaktieren' },
    card: { readTimeUnit: 'Min. Lesezeit' },
  },
  ja: {
    hero: { badge: 'ブログ', title: 'HotelStack.io ブログ', subtitle: '最新のホテル管理のためのインサイト、ガイド、ベストプラクティス' },
    filters: { all: 'すべて', guides: 'ガイド', industry: '業界', product: '製品', trends: 'トレンド' },
    categories: { all: 'すべて', guides: 'ガイド', industry: '業界', product: '製品', trends: 'トレンド' },
    empty: 'このカテゴリに記事が見つかりませんでした。',
    cta: { title: 'ホテルを近代化する準備はできていますか？', subtitle: 'HotelStack.ioを使用して業務を効率化し、収益を向上させている500以上のホテルに参加しましょう。', trialBtn: '無料トライアル開始', contactBtn: '営業に問い合わせ' },
    card: { readTimeUnit: '分で読める' },
  },
  zh: {
    hero: { badge: '博客', title: 'HotelStack.io 博客', subtitle: '现代酒店管理的洞察、指南和最佳实践' },
    filters: { all: '全部', guides: '指南', industry: '行业', product: '产品', trends: '趋势' },
    categories: { all: '全部', guides: '指南', industry: '行业', product: '产品', trends: '趋势' },
    empty: '此类别中未找到文章。',
    cta: { title: '准备好升级您的酒店了吗？', subtitle: '加入500多家使用HotelStack.io优化运营和提高收入的酒店。', trialBtn: '开始免费试用', contactBtn: '联系销售' },
    card: { readTimeUnit: '分钟阅读' },
  },
  hi: {
    hero: { badge: 'ब्लॉग', title: 'HotelStack.io ब्लॉग', subtitle: 'आधुनिक होटल प्रबंधन के लिए अंतर्दृष्टि, गाइड और सर्वोत्तम अभ्यास' },
    filters: { all: 'सभी', guides: 'गाइड', industry: 'उद्योग', product: 'उत्पाद', trends: 'रुझान' },
    categories: { all: 'सभी', guides: 'गाइड', industry: 'उद्योग', product: 'उत्पाद', trends: 'रुझान' },
    empty: 'इस श्रेणी में कोई लेख नहीं मिला।',
    cta: { title: 'अपने होटल को आधुनिक बनाने के लिए तैयार हैं?', subtitle: '500+ होटलों से जुड़ें जो HotelStack.io का उपयोग करते हैं।', trialBtn: 'मुफ़्त ट्रायल शुरू करें', contactBtn: 'बिक्री से संपर्क करें' },
    card: { readTimeUnit: 'मिनट पढ़ें' },
  },
};
